import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { CHECKLIST_TYPES, ROLES } from "models";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { ChecklistID, DealerID } from "models";

type CreateChecklistPayload = {
  name: string;
  dealer_id?: DealerID;
};

export const useCreateChecklistMutation = () =>
  useTypedMutation<CreateChecklistPayload, ChecklistID>({
    mutationFn: async payload => (await ApiInstance.post("/checklists/create", payload, ENV.dealerBaseURL)).data.id,
    onSuccess: ({ name, dealer_id }, id) => {
      const queryKey = dealer_id ? ChecklistsDashboardQueryKeys.dealerChecklists(dealer_id) : ChecklistsDashboardQueryKeys.defaultChecklists;
      const checklists = typedQueryClient.getQueryData(queryKey) ?? [];
      if (checklists.some(checklist => checklist.id === id)) return;

      const now = toISOString(new Date());

      typedQueryClient.setQueryData(queryKey, [
        {
          id,
          name,
          dealer_id: dealer_id ?? null,
          created_on: now,
          updated_on: now,
          active: false,
          is_active_for_mechanic: false,
          is_locked: false,
          include_in_reports: false,
          is_category_mode: false,
          check_in_customer: false,
          role_id: dealer_id ? ROLES.DealerAdmin : ROLES.SupportAdmin,
          checklist_type: CHECKLIST_TYPES.Regular,
          template_id: null,
          is_deleted: false
        },
        ...checklists
      ]);
    }
  });
